import { SecureRouteConfig } from '@pjn/vue-core';


// Componentes Page
import HealthCheck from '@/components/HealthCheck.vue';
import HomePage from '@/views/HomePage.vue';
import AdminPage from '@/views/AdminPage.vue';
import NotFoundPage from '@pjn/vue-ui/components/NotFoundPage.vue';



export default [
  {
    // Ruta Health check
    path: '/health',
    name: 'health',
    component: HealthCheck,
    meta: {
      auth: false
    }
  },
  {
    // Ruta Home
    path: '/',
    name: 'Registro de Denuncias',
    component: HomePage,
    meta: {
      auth: false
    }
  },

  {
    // Ruta gestión de magistrados
    path: '/magistrados',
    name: 'Gestión de Magistrados/as',
    component: AdminPage,
    meta: {
      auth: true
    }
  },
  {
    // Ruta gestión de magistrados
    path: '/configuraciones',
    name: 'Configuraciones',
    component: AdminPage,
    meta: {
      auth: true
    }
  },
  {
    // Ruta gestión de magistrados
    path: '/admin',
    name: 'Administrador',
    component: AdminPage,
    meta: {
      auth: true
    }
  },
  {
    // Ruta gestión de magistrados
    path: '/expedientes',
    name: 'Gestión de expedientes',
    component: AdminPage,
    meta: {
      auth: true
    },
    
  },
  {
    // Ruta gestión de magistrados
    path: '/denuncias/:tipo',
    name: 'Registro de denuncias - Vencidas',
    component: AdminPage,
    meta: {
      auth: true
    },
    props: true 
    
  },
  {
    // Ruta gestión de magistrados
    path: '/denuncias',
    name: 'Registro de denuncias',
    component: AdminPage,
    meta: {
      auth: true
    },
    
  },
  {
    // Fallback para ruta no valida (debe ir al final)
    path: '*',
    name: 'Página no encontrada',
    component: NotFoundPage,
    meta: {
      auth: false
    }
  }
] as SecureRouteConfig[];
